export const firebaseConfigProduction = {
  apiKey: "AIzaSyDENtPBXn0-lxb3HPhiiT8kcIw-VJ5dPgo",
  authDomain: "app.loanvidya.com",
  projectId: "loan-vidya-prod-167b8",
  storageBucket: "loan-vidya-prod-167b8.appspot.com",
  messagingSenderId: "354386466788",
  appId: "1:354386466788:web:8c4ad74afceecc370e59f1",
  measurementId: "G-C6LCNNNHY9"
}